import { trackEvent } from "../shared/mixpanel";
import inviteClient from "./invitaionApis";

export const Content_Refinement = async ({ content, action, tone }) => {
  try {
    const actionInstructions = {
      rewrite: "Rewrite the following post in a fresh way while keeping the same meaning:",
      shorten: "Make the following post shorter and more concise while keeping the key message:",
      expand: "Expand the following post with more detail and depth:",
      change_tone: `Rewrite the following post in a ${tone || "professional"} tone:`,
    };
    const instruction = actionInstructions[action] || `${action} the following post:`;
    const topic = `${instruction}\n\n${content}`;
    const response = await inviteClient.post("content/generate", { topic, xMaxCharacters: 280 }, { timeout: 60000 });
    trackEvent("AI Content Refined", { action, tone });
    return {
      refinedText: response.data?.contentGenerateResponseDTO?.generatedText,
    };
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Something went wrong!";
    throw new Error(errorMessage);
  }
};

export const Content_Generation = async (postData) => {
    try {
      const response = await inviteClient.post("content/generate", postData, {
        timeout: 60000,
      });
      trackEvent("AI Content Generated", {});
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Something went wrong!";
      throw new Error(errorMessage);
    }
  };